/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from "react";
import SpecialPermissionAssignedEmployeesApp from "../Functionality/SpecialPermissionAssignedEmployeesApp";
import CustomAssignedItems from "../../../../../../../components/CustomAvailableAssignedItems/CustomAssignedItems";
import {SEARCH_MODEL} from "../../../../../../../components/table/Model/TableModel";
import {
    GetSpecialPermissionAssigned
} from "../../../../../../../reduxToolkit/UserSpecialPermission/UserSpecialPermissionApi";
import {VIEW_TYPE} from "../../../../../../../enums/ViewType";
import DeleteModal from "../../../../../../Modals/DeleteModal";

const SpecialPermissionAssignedEmployees = (props) => {
    const {
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        registerAction,
        selected,
        setSelected,
        isAllChecked,
        setIsAllChecked
    } = props;

    const {
        t,
        deletePermission,
        handleDelete,
        onDelete,
        hide,
        deleteModalShow
    } = SpecialPermissionAssignedEmployeesApp({
        selected,
        setSelected,
        setIsAllChecked,
        registerAction,
        setModified
    });

    return (
        <>
            <CustomAssignedItems
                setBodyForExport={setBodyForExport}
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                selected={selected}
                setSelected={setSelected}
                labelRowsPerPage={"employees_per_page"}
                tableNotInformationLegend={'you_have_not_assigned_any_employee_yet'}
                tableBuildBody={({ page, rowsPerPage, searchElement }) => SEARCH_MODEL.setObject({ page: page, size: rowsPerPage, key: searchElement }) }
                tableEndPoint={GetSpecialPermissionAssigned}
                keyId={"userId"}
                viewTypeName={VIEW_TYPE.GRID.name}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                onDelete={deletePermission ? handleDelete : undefined}
                checkbox={deletePermission}
            />

            { deleteModalShow &&
                <DeleteModal
                    show={deleteModalShow}
                    onHide={hide}
                    onClickFn={onDelete}
                    data={selected}
                    title_modal={t('remove_employees')}
                    description={'are_you_sure_you_want_to_remove'}
                    element_modal={t('employees')}
                    buttonCancelText={'cancel'}
                />
            }

        </>
    );

}

export default SpecialPermissionAssignedEmployees
